/**
 * Created by andreyna on 8/1/2017.
 */
const CONTAINER_DIRECTION = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical'
}

const SCROLLABLE_CONTAINER_CLASSES = {
    SCROLLING_CONTAINER: 'cgp-scrolling-container',
    SCROLLING_WRAPPER_CONTAINER: 'cgp-scrolling-container-wrapper',
    HORIZONTAL_VIEW: 'cgp-sc-horizontal',
    VERTICAL_VIEW: 'cgp-sc-vertical',
    LEFT_ARROW: 'cgp-sc-left-arrow-wrapper',
    RIGHT_ARROW: 'cgp-sc-right-arrow-wrapper',
    UP_ARROW: 'cgp-sc-up-arrow-wrapper',
    DOWN_ARROW: 'cgp-sc-down-arrow-wrapper',
    ITEM_ELEMENT: 'cgp-sc-item',
    SC_OVERFLOW_AUTO: 'cgp-sc-overflow-auto',
    SC_CENTER_ITEMS: 'cgp-sc-center-items',
    SC_ROW_GRID: 'cgp-sc-row-grid'
}

const PADDING_INDEX = {
    TOP: 0, RIGHT: 1, BOTTOM: 2, LEFT: 3
}

const SCROLL_DIRECTION = {
    LEFT: 'left',
    RIGHT: 'right',
    UP: 'up',
    DOWN: 'down'
}

const INLINE_STYLES = {
    CONTAINER_ITEM: '.cgp-scrollable-container-component .cgp-scrolling-container-wrapper .cgp-scrolling-container .cgp-sc-item',
    SCROLLING_COMPONENT: '.cgp-scrollable-container-component'
}

export {CONTAINER_DIRECTION, SCROLLABLE_CONTAINER_CLASSES, PADDING_INDEX, SCROLL_DIRECTION, INLINE_STYLES};